<template>
  <layout class="support" :useBanner="false">

    <!-- 首图 -->
    <Banner :data="info.banner" />

    <!-- 全栈区块链开源技术方案 -->
    <TechnicalSolutions :data="info.blockchain" />

    <!-- 应用场景 -->
    <Application :data="info.application" />

    <!-- 开发教程 -->
    <DevelopCourse :data="info.developcourse" />

    <!-- 培训视频 -->
    <TrainingVideo :data="info.training" />

    <!-- 底部二维码 -->
    <Bottom :data="info.bottom" />
  </layout>
</template>

<script>
import layout from '@/components/layout/layout'

import Banner from './Banner'
import TechnicalSolutions from './TechnicalSolutions'
import DevelopCourse from './DevelopCourse'
import TrainingVideo from './TrainingVideo'
import Application from './Application'
import Bottom from './Bottom'

export default {
  name: 'Home',
  components: {
    layout,
    Banner,
    TechnicalSolutions,
    DevelopCourse,
    TrainingVideo,
    Application,
    Bottom
  },
  computed: {
    info () {
      return this.$t('blockchain')
    }
  }
}
</script>
<style lang="scss" scoped>

.banner-wrapper {
  width: 1200px;
  margin: 0 auto;
}

.banner-img {
  width: 362px; height: 180px;
  margin-top: 178px;
}

@include mobile {

}
</style>
